import React from "react";
import "../styles/Hero.css";

const Hero = ({
  title,
  description,
  ctaText,
  ctaAction,
  backgroundImage,
  additionalImage,
}) => {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="hero-overlay"></div>
      <div className="hero-content">
        {additionalImage && (
          <img
            src={additionalImage}
            alt="Additional"
            className="additional-image"
          />
        )}
        {title && <h1 className="hero-title">{title}</h1>}
        {description && <p className="hero-description">{description}</p>}
        {ctaText && ctaAction && (
          <button className="cta-button" onClick={ctaAction}>
            {ctaText}
          </button>
        )}
      </div>
    </section>
  );
};

export default Hero;
